import { render } from "./ShowDisclaimer.vue?vue&type=template&id=2d943e1c"
import script from "./ShowDisclaimer.vue?vue&type=script&lang=js"
export * from "./ShowDisclaimer.vue?vue&type=script&lang=js"

import exportComponent from "../../../vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__